export default "__VITE_ASSET__vmOa3hoQ__"